module.exports = "/_next/static/images/shield-line-466e34d969b42c0d473cb501cccfa8c9.svg";